export function isEmpty(val) {
  return (
    val === null ||
    val === undefined ||
    val === "" ||
    (val !== null && typeof val === "object" && !Object.keys(val).length)
  );
}

export function isNotEmpty(val) {
  return !isEmpty(val);
}

export function removeEmpty(text) {
  return !isEmpty(text) ? text.replace(/ /g, "") : "";
}

export function removeSpecialText(text, replaceText) {
  const reg = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;
  return !isEmpty(text) ? text.replace(reg, replaceText) : "";
}

export function removeTrim(text) {
  return !isEmpty(text) ? text.replace(/^\s*/, "").replace(/\s*$/, "") : "";
}

export function isObject(val) {
  return val != null && typeof val === "object" && Array.isArray(val) === false;
}

export function isNumeric(value) {
  return /^\d+$/.test(value);
}